import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useAllActiveRadiologistList = () => {
  const [data, setData] = useState();
  const getList = async () => {
    // Fetch users list
    const list = await apiService.getAllActiveRadiologist();
    list && setData(list); // update data state
    return list;
  };

  return {
    data,
    getList,
  };
};
